import { LinkLabelOption } from './link-label-option.interface';

/** Vordefinierte Label-Optionen für externe Links. */
export const LINK_LABEL_OPTIONS: readonly LinkLabelOption[] = [
  { id: 'empty', label: 'Keinen Button anzeigen' },
  { id: 'mehr-erfahren', label: 'Mehr erfahren' },
  { id: 'jetzt-ansehen', label: 'Jetzt ansehen' },
  { id: 'jetzt-anmelden', label: 'Jetzt anmelden' },
  { id: 'details-anzeigen', label: 'Details anzeigen' },
  { id: 'jetzt-buchen', label: 'Jetzt buchen' },
] as const;
